import Type from "@/model/types/Type";

const type = {
    PENDING : 1,
    SCHEDULED : 2,
    BEFORE_PRODUCTION : 3,
    PRODUCTION : 4,
    DONE : 10,
    STOPPED_PRODUCTION : 90,
    REPROVED : 91,
}

const list = [
    {
        value: type.PENDING,
        text: "Pendente",
    },
    {
        value: type.SCHEDULED,
        text: "Programado",
    },
    {
        value: type.BEFORE_PRODUCTION,
        text: "Aguardando início",
    },
    {
        value: type.PRODUCTION,
        text: "Em andamento",
    },
    {
        value: type.STOPPED_PRODUCTION,
        text: "Parado",
    },
    {
        value: type.DONE,
        text: "Finalizado",
    },
    {
        value: type.REPROVED,
        text: "Reprovado",
    },

]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

const hasDone = function(t) {
    return t === type.DONE || t === type.REPROVED
}

export default {
    type,
    list,
    contains,
    hasDone
}


